import { useState } from "react";
import { Inp } from "../ui";
import { SigteSignaturePad } from "./SigteSignaturePad";

// Portado de FirmaSlot en sigte-prototipo.jsx:429-480. Diferencia real: el
// prototipo guardaba {nombre, firma} usando el nombre como identidad; aqui
// guardamos {personalId, nombre, archivo} porque el backend necesita el id
// real de sigte_personal (tecnico_id/supervisor_id), no solo el nombre.
export function SigteFirmaSlot(p) {
  var esCliente = p.catalogoRol === "cliente";
  var [mostrarNuevo, setMostrarNuevo] = useState(false);
  var [nuevoNombre, setNuevoNombre] = useState("");

  var nombreFinal = p.value.nombre;

  function agregarNuevo() {
    if (!nuevoNombre.trim()) return;
    p.onAgregarPersonal(nuevoNombre.trim(), p.catalogoRol, function (nuevoPersonal) {
      p.onChange(Object.assign({}, p.value, { personalId: nuevoPersonal.id, nombre: nuevoPersonal.nombre }));
    });
    setNuevoNombre(""); setMostrarNuevo(false);
  }

  function seleccionar(idStr) {
    var id = idStr ? parseInt(idStr, 10) : null;
    var per = p.personal.find(function (x) { return x.id === id; });
    p.onChange(Object.assign({}, p.value, { personalId: id, nombre: per ? per.nombre : "" }));
  }

  return (
    <div style={{ border: "1px solid #e2e8f0", borderRadius: 14, padding: 16, background: "#fff" }}>
      <div style={{ marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{p.titulo}</p>
        {p.value.archivo ? <span style={{ fontSize: 11, fontWeight: 600, color: "#059669" }}>Firmada</span> : null}
      </div>

      {esCliente ? (
        <div style={{ marginBottom: 8 }}>
          <Inp value={p.value.nombre || ""} placeholder="Nombre del representante del cliente"
            onChange={function (e) { p.onChange(Object.assign({}, p.value, { nombre: e.target.value })); }} />
        </div>
      ) : mostrarNuevo ? (
        <div style={{ marginBottom: 8, display: "flex", gap: 6 }}>
          <Inp value={nuevoNombre} onChange={function (e) { setNuevoNombre(e.target.value); }} placeholder="Nombre completo" />
          <button type="button" onClick={agregarNuevo} style={{ padding: "0 12px", borderRadius: 8, border: "none", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Agregar</button>
          <button type="button" onClick={function () { setMostrarNuevo(false); }} style={{ padding: "0 10px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", color: "#94a3b8", cursor: "pointer" }}>X</button>
        </div>
      ) : (
        <div style={{ marginBottom: 8, display: "flex", gap: 6 }}>
          <select value={p.value.personalId || ""} onChange={function (e) { seleccionar(e.target.value); }}
            style={{ flex: 1, border: "1px solid #dde3f0", borderRadius: 8, padding: "7px 10px", fontSize: 12, background: "#f7f9fc" }}>
            <option value="">Selecciona un nombre...</option>
            {p.personal.filter(function (per) { return per.rol === p.catalogoRol || per.rol === "ambos"; }).map(function (per) {
              return <option key={per.id} value={per.id}>{per.nombre}</option>;
            })}
          </select>
          <button type="button" onClick={function () { setMostrarNuevo(true); }} title="Agregar nombre nuevo"
            style={{ padding: "0 10px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", cursor: "pointer" }}>+</button>
        </div>
      )}

      <SigteSignaturePad guardada={!!p.value.archivo} deshabilitado={!nombreFinal}
        onSave={function (filename) { p.onChange(Object.assign({}, p.value, { archivo: filename })); }} />
      {!nombreFinal ? <p style={{ marginTop: 6, fontSize: 11, color: "#94a3b8" }}>Elige un nombre antes de guardar la firma.</p> : null}
    </div>
  );
}
